import React, { useState } from 'react';
import { api } from '../services/api';

export default function ForgotDetails({ onBack }) {
  const [mode, setMode]           = useState('username'); // 'username' | 'email'
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading]     = useState(false);
  const [sent, setSent]           = useState(false);
  const [error, setError]         = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.forgotDetails(mode, identifier);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, overflowY:'auto', background:'#0f172a',
      backgroundImage:'radial-gradient(ellipse 80% 60% at 50% 0%,rgba(79,70,229,.22) 0%,transparent 65%)',
      fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif' }}>

      <nav style={{ height:64, padding:'0 5%', display:'flex', alignItems:'center',
        justifyContent:'space-between', borderBottom:'1px solid rgba(255,255,255,.06)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:34, height:34, borderRadius:9, overflow:'hidden' }}>
            <img src="/icon-192.png" alt="Seva" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          </div>
          <span style={{ fontSize:18, fontWeight:800, color:'#f1f5f9', letterSpacing:'-0.3px' }}>Seva</span>
        </div>
        <button onClick={onBack} style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)',
          borderRadius:8, padding:'7px 16px', color:'rgba(255,255,255,.55)', fontSize:14,
          fontWeight:500, cursor:'pointer' }}>← Back</button>
      </nav>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
        minHeight:'calc(100vh - 64px)', padding:'40px 5%' }}>
        <div style={{ width:420, padding:'40px 44px', background:'#fff',
          borderRadius:22, boxShadow:'0 40px 80px rgba(0,0,0,.45)' }}>

          {sent ? (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:16 }}>📬</div>
              <h2 style={{ fontSize:20, fontWeight:800, color:'#0f172a', margin:'0 0 10px' }}>Check your inbox</h2>
              <p style={{ fontSize:14, color:'#64748b', lineHeight:1.6, margin:'0 0 24px' }}>
                If an account matching that {mode === 'username' ? 'username' : 'email'} exists and has an email address on file, we've sent you an email with next steps.
              </p>
              <button onClick={onBack} style={btnStyle}>← Back to sign in</button>
            </div>
          ) : (
            <>
              <div style={{ textAlign:'center', marginBottom:28 }}>
                <h1 style={{ fontSize:22, fontWeight:800, color:'#0f172a', margin:'0 0 8px' }}>Forgot your details?</h1>
                <p style={{ fontSize:14, color:'#64748b', margin:0 }}>{mode === 'username' ? 'Enter your username and we\'ll send a password reset link.' : 'Enter your email and we\'ll send your username.'}</p>
              </div>

              {/* Mode toggle */}
              <div style={{ display:'flex', background:'#f1f5f9', borderRadius:10, padding:4, marginBottom:24 }}>
                {[['username','Forgot password'],['email','Forgot username']].map(([val, label]) => (
                  <button key={val} onClick={() => { setMode(val); setIdentifier(''); setError(''); }}
                    style={{ flex:1, border:'none', borderRadius:7, padding:'8px 4px', fontSize:13, fontWeight:600,
                      cursor:'pointer', transition:'all .15s',
                      background: mode===val ? '#fff' : 'transparent',
                      color: mode===val ? '#4f46e5' : '#64748b',
                      boxShadow: mode===val ? '0 1px 4px rgba(0,0,0,.1)' : 'none' }}>
                    {label}
                  </button>
                ))}
              </div>

              <form onSubmit={handleSubmit}>
                {error && (
                  <div style={{ background:'#fef2f2', color:'#dc2626', border:'1px solid #fecaca',
                    borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:16 }}>{error}</div>
                )}

                <div style={{ marginBottom:20 }}>
                  <label style={lbl}>{mode === 'username' ? 'Username' : 'Email address'}</label>
                  <input style={inp} type={mode === 'email' ? 'email' : 'text'}
                    value={identifier} onChange={e => setIdentifier(e.target.value)}
                    placeholder={mode === 'username' ? 'Enter your username' : 'Enter your email'}
                    required autoFocus />
                </div>

                <button type="submit" style={btnStyle} disabled={loading}>
                  {loading ? 'Sending…' : 'Send email →'}
                </button>
              </form>

              {mode === 'username' && (
                <p style={{ marginTop:16, fontSize:12, color:'#94a3b8', textAlign:'center', lineHeight:1.5 }}>
                  Don't know your username?{' '}
                  <button onClick={() => { setMode('email'); setIdentifier(''); }}
                    style={{ background:'none', border:'none', color:'#4f46e5', cursor:'pointer', fontSize:12, padding:0, fontWeight:600 }}>
                    Recover it instead
                  </button>
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const lbl = { display:'block', fontSize:11, fontWeight:700, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:'.06em' };
const inp = { width:'100%', background:'#f8fafc', border:'1.5px solid #e2e8f0', borderRadius:10, padding:'11px 14px', fontSize:14, color:'#0f172a', outline:'none', boxSizing:'border-box', fontFamily:'inherit' };
const btnStyle = { width:'100%', background:'#4f46e5', border:'none', borderRadius:10, padding:'13px', fontSize:15, fontWeight:700, color:'#fff', cursor:'pointer', boxShadow:'0 2px 12px rgba(79,70,229,.3)' };
